import styled from "styled-components";
import Button from "@material-ui/core/Button";

export const CallToActionButton = styled(Button).attrs({
  variant: "contained",
  size: "large",
  color: "primary"
})`
  && {
    color: white;
    font-weight: 800;
    font-size: 1rem;
    text-transform: none;
  }
`;
